import React, { useContext, useMemo } from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from '../Items/Navbar';
import PageMeta from '../seo/PageMeta';
import AuthContext from '../shared/AuthContext';
import AdminConsoleNav from './AdminConsoleNav';
import './adminConsole.css';

export default function AdminConsoleLayout() {
  const { user, isLoading } = useContext(AuthContext);

  const userProfile = useMemo(() => {
    try {
      return JSON.parse(localStorage.getItem('userProfile') || 'null') || user;
    } catch {
      return user;
    }
  }, [user]);

  return (
    <>
      <PageMeta title="Admin console" description="QnaRead platform management" />
      <Navbar userProfile={userProfile} loading={isLoading} />
      <div className="admin-console">
        <p className="admin-console-eyebrow">Admin console</p>
        <AdminConsoleNav />
        <main className="admin-console-main">
          <Outlet />
        </main>
      </div>
    </>
  );
}
